export enum VOUCHER {
  INPUT = "voucherInputField",
  APPLY = "voucherApplyButton",
  SUCCESS_MESSAGE = "voucherSuccessMessage",
  ERROR_MESSAGE = "voucherErrorMessage",
  ERROR_MESSAGE_TOAST = "voucherErrorMessageToast",
}
